export const VIDEO_SPRITESHEET_FRAME_COUNT = 50;

export const VIDEO_SPRITESHEET_COLUMN_COUNT = 5;

export const VIDEO_SPRITESHEET_ROW_COUNT = 10;
